import React from 'react';
import { Body2 } from 'ui/theme';
import { Result } from './SplitResult.styles';
import { ResultType } from '../PreviewYesNoSplitModal.constants';

export const SINGLE_RESULT_TEST_ID = 'single-result';

export interface SingleResultProps {
  /** The result type of this item */
  expected: ResultType;
  /** The result type that is actually set */
  actual: ResultType;
}

const SingleResult = ({
  actual,
  expected,
  children,
}: React.PropsWithChildren<SingleResultProps>) => {
  const active = actual === expected;
  return (
    <Result
      data-test={SINGLE_RESULT_TEST_ID}
      data-expected={expected}
      data-actual={actual}
      data-active={active}
      $active={active}
    >
      <Body2>{children}</Body2>
    </Result>
  );
};

export default SingleResult;
